(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lma-adv-01-announce"] && !Shopify.designMode) return;
  try {
    
(function () {
  var BAR_SELECTOR = '[data-adv-s01-bar]';
  var MSG_SELECTOR = '[data-adv-s01-msg]';
  var MIN_DELAY = 3000;

  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  /* Visitors who ask their system for reduced motion get a static bar: the first message stays,
     nothing rotates on its own. The CSS drops the transition, this drops the timer. */
  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function collect(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var found = toArray(scope.querySelectorAll(BAR_SELECTOR));
    if (scope.matches && scope.matches(BAR_SELECTOR)) {
      found.unshift(scope);
    }
    return found;
  }

  function apply(messages, index) {
    for (var i = 0; i < messages.length; i++) {
      var isActive = i === index;
      if (isActive) {
        messages[i].classList.add('is-active');
        messages[i].removeAttribute('aria-hidden');
      } else {
        messages[i].classList.remove('is-active');
        messages[i].setAttribute('aria-hidden', 'true');
      }
      var link = messages[i].querySelector('.adv-s01__link');
      if (link) {
        link.setAttribute('tabindex', isActive ? '0' : '-1');
      }
    }
  }

  function initBar(bar) {
    if (!bar || bar.getAttribute('data-adv-s01-ready') === 'true') {
      return;
    }
    bar.setAttribute('data-adv-s01-ready', 'true');

    var messages = toArray(bar.querySelectorAll(MSG_SELECTOR));
    if (!messages.length) {
      return;
    }

    var index = 0;
    apply(messages, index);

    if (bar.getAttribute('data-adv-s01-rotate') !== 'true' || messages.length < 2) {
      return;
    }

    var delay = parseInt(bar.getAttribute('data-adv-s01-interval'), 10);
    if (isNaN(delay) || delay < MIN_DELAY) {
      delay = 4000;
    }

    var paused = false;

    function hold() {
      paused = true;
    }

    function release() {
      paused = false;
    }

    bar.addEventListener('mouseenter', hold);
    bar.addEventListener('mouseleave', release);
    bar.addEventListener('focusin', hold);
    bar.addEventListener('focusout', release);

    function stop() {
      if (bar.advS01Timer) {
        window.clearInterval(bar.advS01Timer);
        bar.advS01Timer = null;
      }
    }

    function start() {
      /* isConnected guard: in the customizer the section is torn down and rebuilt, and the
         media query listener below outlives the old node. Never revive a detached bar. */
      if (bar.advS01Timer || reducedMotion() || bar.isConnected === false) {
        return;
      }
      bar.advS01Timer = window.setInterval(function () {
        if (paused || document.hidden) {
          return;
        }
        index = (index + 1) % messages.length;
        apply(messages, index);
      }, delay);
    }

    /* The preference can change while the page is open, so the timer follows it both ways. */
    if (window.matchMedia) {
      var query = window.matchMedia('(prefers-reduced-motion: reduce)');
      var onChange = function () {
        if (query.matches) {
          stop();
        } else {
          start();
        }
      };
      if (query.addEventListener) {
        query.addEventListener('change', onChange);
      } else if (query.addListener) {
        query.addListener(onChange);
      }
    }

    start();
  }

  function initAll(root) {
    collect(root).forEach(initBar);
  }

  function stopAll(root) {
    collect(root).forEach(function (bar) {
      if (bar.advS01Timer) {
        window.clearInterval(bar.advS01Timer);
        bar.advS01Timer = null;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    stopAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lma-adv-04-stories"] && !Shopify.designMode) return;
  try {
    
(function () {
  var track = document.getElementById('advS04Track');
  var dots = document.getElementById('advS04Dots');
  if (!track || !dots) return;
  var items = dots.querySelectorAll('.adv-s04__dot');
  if (!items.length) return;
  var raf = null;
  track.addEventListener('scroll', function () {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = null;
      var cards = track.children;
      if (!cards.length) return;
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var c = cards[i];
        var center = c.offsetLeft + c.offsetWidth / 2;
        var d = Math.abs(center - mid);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      for (var j = 0; j < items.length; j++) {
        items[j].classList.toggle('is-active', j === best);
      }
    });
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lma-adv-05-buy"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sec = document.getElementById('adv-buy');
  if (!sec) return;
  var modal = sec.querySelector('[data-adv-sg]');
  if (!modal) return;


  /* Les boutons de la page pointent tous vers #adv-buy. Une ancre saute d un
     coup ; Pierre veut un glissement.

     PIEGE PAYE LE 2026-08-25 : la premiere version confiait le glissement a
     scrollIntoView({behavior:'smooth'}). Mesure faite sur la page vivante :
     dans ce navigateur, 'smooth' ne defile PAS DU TOUT (0 px), quand 'auto'
     saute correctement a 1863 — et prefers-reduced-motion etait bien a false.
     Un bouton d achat qui ne fait rien coute plus cher que tout le reste de
     la page reunie. On anime donc nous memes, image par image : ca ne depend
     d aucune implementation optionnelle du navigateur.

     Le geste du visiteur (molette, doigt, touche) interrompt l animation :
     rien n est plus desagreable qu une page qui se bat contre vous. */
  (function () {
    var sobre = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var DUREE = 620;

    function glisser(vers) {
      var depart = window.pageYOffset || document.documentElement.scrollTop;
      var delta = vers - depart;
      if (!delta) return;
      var t0 = null, coupe = false;
      function stop() { coupe = true; }
      var gestes = ['wheel', 'touchstart', 'keydown'];
      for (var i = 0; i < gestes.length; i++) window.addEventListener(gestes[i], stop, { passive: true, once: true });

      function pas(t) {
        if (coupe) return fin();
        if (t0 === null) t0 = t;
        var k = Math.min(1, (t - t0) / DUREE);
        var e = 1 - Math.pow(1 - k, 3);   /* sortie douce */
        window.scrollTo(0, Math.round(depart + delta * e));
        if (k < 1) requestAnimationFrame(pas); else fin();
      }
      function fin() {
        clearTimeout(filet);
        for (var i = 0; i < gestes.length; i++) window.removeEventListener(gestes[i], stop);
      }
      /* Filet. requestAnimationFrame est SUSPENDU dans un onglet en arriere
         plan : mesure du 2026-08-25, zero image en 600 ms sur un onglet
         cache. Sans ce filet, un clic declenche dans cet etat laisserait le
         visiteur sur place. Au pire l arrivee est seche, jamais absente. */
      var filet = setTimeout(function () {
        if (coupe) return;
        var ou = window.pageYOffset || document.documentElement.scrollTop;
        if (Math.abs(ou - vers) > 2) window.scrollTo(0, vers);
        fin();
      }, DUREE + 120);
      requestAnimationFrame(pas);
    }

    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href*="#adv-"]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var i = href.indexOf('#');
      if (i < 0) return;
      var avant = href.slice(0, i);
      /* On ne detourne que les liens qui restent sur la page courante. */
      if (avant && avant.indexOf(location.pathname) !== 0 && avant.charAt(0) !== '?') return;
      var cible = document.getElementById(href.slice(i + 1));
      if (!cible) return;
      e.preventDefault();
      var y = cible.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop);
      /* Marge haute : la barre collante du theme mange une bande en haut. */
      var barre = document.querySelector('.section-header, .header-wrapper, [data-sticky-header]');
      if (barre) {
        var bs = getComputedStyle(barre);
        if (bs.position === 'fixed' || bs.position === 'sticky') y -= barre.getBoundingClientRect().height;
      }
      y = Math.max(0, Math.round(y));
      if (sobre) window.scrollTo(0, y); else glisser(y);
      if (history.replaceState) history.replaceState(null, '', href.slice(i));
    });
  })();

  /* Compteur de commandes. Volontairement DETERMINISTE sur l heure courante :
     tous les visiteurs d une meme heure voient le meme nombre, et il ne saute
     pas pendant qu on lit la page. Un nombre qui papillonne se repere en trois
     secondes et detruit la credibilite du reste. */
  (function () {
    var n = sec.querySelector('[data-adv-orders]');
    if (!n) return;
    var cible = n.querySelector('[data-adv-orders-n]');
    if (!cible) return;
    var min = parseInt(n.getAttribute('data-min'), 10);
    var max = parseInt(n.getAttribute('data-max'), 10);
    if (isNaN(min) || isNaN(max) || max <= min) return;

    function poser() {
      var d = new Date();
      /* graine stable a l heure pres */
      var graine = d.getFullYear() * 1000000 + (d.getMonth() + 1) * 10000 + d.getDate() * 100 + d.getHours();
      var x = Math.sin(graine) * 10000;
      var frac = x - Math.floor(x);
      cible.textContent = min + Math.floor(frac * (max - min + 1));
    }
    poser();
    /* on repasse a chaque changement d heure, pour les onglets restes ouverts */
    setInterval(poser, 60000);
  })();

  /* Ligne d expedition, les deux valeurs dynamiques.

     DATE : rendue cote serveur a la date du jour, puis avancee ici du nombre
     de jours du reglage. Le cache de page Shopify peut servir un rendu de la
     veille ; le calcul cote client repart donc de l horloge du visiteur, ce
     qui est la seule source juste pour lui.

     LIEU : lu sur /browsing_context_suggestions.json, l endpoint de Shopify
     lui-meme. Aucun service tiers, aucune donnee du visiteur qui sort du
     domaine. Il rend le PAYS, jamais l etat, et on s en tient la : les
     Etats-Unis pour un visiteur americain, le nom du pays sinon. */
  (function () {
    var LOC = 'en-US';
    var jours = parseInt(sec.getAttribute('data-adv-ship-offset') || '1', 10);
    if (isNaN(jours)) jours = 1;

    var cibleDate = sec.querySelector('[data-adv-shipdate]');
    if (cibleDate) {
      var d = new Date();
      d.setDate(d.getDate() + jours);
      try {
        cibleDate.textContent = d.toLocaleDateString(LOC, { month: 'short', day: 'numeric' });
      } catch (e) { /* on garde le rendu serveur */ }
    }

    var DRAPEAUX = { US: '\uD83C\uDDFA\uD83C\uDDF8' };
    function drapeau(code) {
      if (!code || code.length !== 2) return '';
      if (DRAPEAUX[code]) return DRAPEAUX[code];
      return String.fromCodePoint(0x1F1E6 + code.charCodeAt(0) - 65)
           + String.fromCodePoint(0x1F1E6 + code.charCodeAt(1) - 65);
    }

    var champ = sec.querySelector('[data-adv-shiptoText]');
    var champDrapeau = sec.querySelector('[data-adv-flag]');
    if (!champ) return;

    function poser(texte, code) {
      champ.textContent = texte;
      if (champDrapeau) champDrapeau.textContent = drapeau(code);
    }

    fetch('/browsing_context_suggestions.json?country[enabled]=true', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var det = j && j.detected_values && j.detected_values.country;
        if (!det || !det.handle) return;
        if (det.handle !== 'US') { poser(det.name || det.handle, det.handle); return; }
        /* Pas de deduction d etat. Shopify ne rend que le pays, et le fuseau
           horaire ne designe un etat unique que dans une poignee de cas.
           Arbitrage de Pierre le 2026-08-25 : mieux vaut le pays, juste a tous
           les coups, qu un etat devine qui semera le doute des qu il se trompe. */
        poser('the United States', 'US');
      })
      .catch(function () { /* on garde le repli du reglage */ });
  })();

  /* La vignette de chaque ligne suit la couleur choisie.
     La carte couleur vers image se lit dans le JSON de variantes deja pose
     par le composant : les 81 variantes portent toutes un featured_image, et
     l option de couleur est a l index 1. On ne rajoute donc aucune donnee.
     Delegation sur le document plutot qu abonnement par ligne : le module du
     theme peut refabriquer les lignes, et un abonnement pose une fois serait
     perdu. */
  (function () {
    var src = sec.querySelector('[data-lma-variants]');
    if (!src) return;
    var variantes;
    try { variantes = JSON.parse(src.textContent); } catch (e) { return; }
    if (!variantes || !variantes.length) return;

    var parCouleur = {};
    for (var i = 0; i < variantes.length; i++) {
      var v = variantes[i];
      var c = v.options && v.options[1];
      if (c && !parCouleur[c] && v.featured_image && v.featured_image.src) {
        parCouleur[c] = v.featured_image.src;
      }
    }

    function taillee(url, largeur) {
      if (!url) return url;
      return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + largeur;
    }

    function poser(select) {
      var ligne = select.closest('[data-variant-row]');
      if (!ligne) return;
      var img = ligne.querySelector('img');
      var url = parCouleur[select.value];
      if (!img || !url) return;
      if (img.getAttribute('data-adv-couleur') === select.value) return;
      img.setAttribute('data-adv-couleur', select.value);
      /* srcset d abord vide : sinon le navigateur garde l ancien candidat et
         le src neuf n est jamais retenu. */
      /* Une seule source, en 240. Avec un srcset et sizes a 40px, le
         navigateur choisissait le plus petit candidat — 40 pixels de large —
         et le zoom de 2 le rendait flou. La vignette pese quelques kilo-octets,
         la finesse vaut mieux que l economie ici. */
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.setAttribute('src', taillee(url, 240));
    }

    function poserTout() {
      var l = sec.querySelectorAll('[data-variant-row] [data-adv-color]');
      for (var i = 0; i < l.length; i++) poser(l[i]);
    }

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('[data-adv-color]')) poser(t);
    });
    /* Au chargement, on aligne la vignette sur la couleur deja selectionnee :
       l image rendue par Liquid est celle du produit, pas celle du coloris. */
    poserTout();
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.type === 'radio') setTimeout(poserTout, 80);
    });
  })();

  // Les puces de galerie ont ete retirees le 2026-08-25 : leur pilote aussi.

  // Pastille de couleur du controle : elle prend la teinte de l option choisie.
  sec.querySelectorAll('[data-adv-color]').forEach(function (sel) {
    var dot = sel.parentElement.querySelector('[data-adv-dot]');
    function sync() {
      var o = sel.options[sel.selectedIndex];
      if (dot && o) dot.style.setProperty('--adv-dot', o.getAttribute('data-hex') || '#d9d9d9');
    }
    sel.addEventListener('change', sync);
    sync();
  });

  function open() { modal.removeAttribute('hidden'); document.body.style.overflow = 'hidden'; }
  function close() { modal.setAttribute('hidden', ''); document.body.style.overflow = ''; }

  sec.querySelectorAll('[data-adv-sg-open]').forEach(function (b) { b.addEventListener('click', open); });
  modal.querySelectorAll('[data-adv-sg-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  // Bascule pouces / centimetres. Les deux valeurs sont rendues par le serveur,
  // on ne fait que montrer l une et cacher l autre : aucune conversion en JS,
  // donc aucun arrondi qui deriverait de la table de reference.
  modal.querySelectorAll('[data-adv-sg-unit]').forEach(function (b) {
    b.addEventListener('click', function () {
      var unit = b.getAttribute('data-adv-sg-unit');
      modal.querySelectorAll('[data-adv-sg-unit]').forEach(function (o) { o.classList.toggle('is-on', o === b); });
      modal.querySelectorAll('[data-adv-in]').forEach(function (n) { n.hidden = unit !== 'in'; });
      modal.querySelectorAll('[data-adv-cm]').forEach(function (n) { n.hidden = unit !== 'cm'; });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lma-adv-07-timeline"] && !Shopify.designMode) return;
  try {
    
(function () {
  var start = function () {
    var sections = document.querySelectorAll('.adv-s07[data-adv-s07-animate]');
    if (!sections.length) { return; }

    for (var i = 0; i < sections.length; i++) {
      sections[i].classList.add('adv-s07--anim');
    }

    if (!('IntersectionObserver' in window)) {
      for (var k = 0; k < sections.length; k++) { sections[k].classList.add('is-in'); }
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      for (var n = 0; n < entries.length; n++) {
        if (entries[n].isIntersecting) {
          entries[n].target.classList.add('is-in');
          io.unobserve(entries[n].target);
        }
      }
    }, { threshold: 0.2 });

    for (var j = 0; j < sections.length; j++) { io.observe(sections[j]); }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lma-adv-08-beforeafter"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initAdvS08(root) {
    if (root.getAttribute('data-adv-s08-ready') === '1') { return; }
    root.setAttribute('data-adv-s08-ready', '1');

    var rail = root.querySelector('[data-adv-s08-rail]');
    var dots = root.querySelector('[data-adv-s08-dots]');
    var cards = rail ? rail.querySelectorAll('.adv-s08__card') : [];
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (rail && dots && cards.length > 1) {
      var buttons = [];
      for (var i = 0; i < cards.length; i++) {
        (function (index) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'adv-s08__dot';
          b.setAttribute('aria-current', index === 0 ? 'true' : 'false');
          b.setAttribute('aria-label', 'Show story ' + (index + 1) + ' of ' + cards.length);
          b.innerHTML = '<span class="adv-s08__dot-i"></span>';
          b.addEventListener('click', function () {
            var left = cards[index].offsetLeft - cards[0].offsetLeft;
            if (rail.scrollTo) {
              rail.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
            } else {
              rail.scrollLeft = left;
            }
          });
          dots.appendChild(b);
          buttons.push(b);
        })(i);
      }

      var sync = function () {
        var step = cards[1].offsetLeft - cards[0].offsetLeft;
        var current = step > 0 ? Math.round(rail.scrollLeft / step) : 0;
        if (current < 0) { current = 0; }
        if (current > buttons.length - 1) { current = buttons.length - 1; }
        for (var j = 0; j < buttons.length; j++) {
          buttons[j].setAttribute('aria-current', j === current ? 'true' : 'false');
        }
      };

      var ticking = false;
      rail.addEventListener('scroll', function () {
        if (ticking) { return; }
        ticking = true;
        window.requestAnimationFrame(function () { sync(); ticking = false; });
      });
      sync();
    }

    var groups = root.querySelectorAll('[data-adv-s08-reveal]');
    if (!reduce && groups.length && 'IntersectionObserver' in window) {
      root.classList.add('adv-s08__reveal-ready');
      var io = new IntersectionObserver(function (entries) {
        for (var k = 0; k < entries.length; k++) {
          if (entries[k].isIntersecting) {
            entries[k].target.classList.add('is-in');
            io.unobserve(entries[k].target);
          }
        }
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      for (var g = 0; g < groups.length; g++) { io.observe(groups[g]); }
    }

    var links = root.querySelectorAll('a[data-adv-s08-scroll]');
    for (var l = 0; l < links.length; l++) {
      links[l].addEventListener('click', function (event) {
        var href = this.getAttribute('href') || '';
        if (href.charAt(0) !== '#' || href.length < 2) { return; }
        var target = document.getElementById(href.slice(1));
        if (!target) { return; }
        event.preventDefault();
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        if (typeof target.focus === 'function') {
          if (!target.hasAttribute('tabindex')) { target.setAttribute('tabindex', '-1'); }
          try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
        }
      });
    }
  }

  function bootAdvS08() {
    var roots = document.querySelectorAll('.adv-s08');
    for (var i = 0; i < roots.length; i++) { initAdvS08(roots[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAdvS08);
  } else {
    bootAdvS08();
  }
  document.addEventListener('shopify:section:load', bootAdvS08);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lma-adv-09-ugc"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sec = document.getElementById('adv-ugc');
  if (!sec) return;
  var reels = sec.querySelectorAll('.adv-s09__reel');
  if (!reels.length) return;

  // Chargement paresseux : la source n est posee qu au moment ou la tuile entre
  // dans le champ. Six videos chargees au premier octet coutent la page entiere
  // en donnees mobiles.
  // Lancer la lecture au moment ou l on pose la source echoue : la promesse de
  // play() est rejetee tant que les metadonnees ne sont pas la, et le rejet est
  // silencieux. On attend donc canplay, ce qui laissait sinon six tuiles noires.
  function start(v) {
    if (!v) return;
    v.muted = true;
    var go = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    if (!v.getAttribute('src') && v.dataset.src) {
      v.addEventListener('canplay', go, { once: true });
      // Le fragment #t=0.1 force le navigateur a peindre une premiere image des
      // que la source est posee. Sans lui, une tuile dont la lecture automatique
      // est refusee (economie de donnees, onglet en arriere plan, iOS bas
      // niveau de batterie) reste un rectangle noir.
      v.setAttribute('src', v.dataset.src + '#t=0.1');
      v.load();
    } else {
      go();
    }
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target.querySelector('video');
      if (!v) return;
      if (e.isIntersecting) {
        start(v);
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { rootMargin: '200px 0px', threshold: 0.25 }) : null;

  reels.forEach(function (r) {
    var v = r.querySelector('video');
    if (io) { io.observe(r); }
    else { start(v); }

    // Un appui bascule le son de cette tuile et coupe les autres.
    r.addEventListener('click', function () {
      if (!v) return;
      var turningOn = v.muted;
      reels.forEach(function (o) {
        var ov = o.querySelector('video');
        if (ov && ov !== v) { ov.muted = true; o.classList.remove('is-live'); }
      });
      start(v);
      v.muted = !turningOn;
      r.classList.toggle('is-live', turningOn);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lma-adv-10-engineered"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sec = document.getElementById('adv-engineered');
  if (!sec) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function countUp(el) {
    var raw = el.getAttribute('data-adv-count');
    var target = parseFloat(raw);
    // Valeur non numerique ou mouvement refuse : on laisse le HTML tel quel,
    // il porte deja la bonne valeur.
    if (isNaN(target) || reduce) return;
    el.textContent = '0';
    var dur = 1100, t0 = null, settled = false;
    function step(ts) {
      if (settled) return;
      if (t0 === null) t0 = ts;
      var k = Math.min(1, (ts - t0) / dur);
      // Sortie en douceur : la valeur ralentit en approchant de la cible.
      el.textContent = String(Math.round(target * (1 - Math.pow(1 - k, 3))));
      if (k < 1) { requestAnimationFrame(step); } else { settled = true; }
    }
    requestAnimationFrame(step);
    // Filet de securite : requestAnimationFrame est totalement suspendu dans un
    // onglet en arriere plan, et le compteur se fige alors sur une valeur fausse
    // (mesure le 2026-08-24 : 4 % au lieu de 30 %). Un minuteur, lui, finit
    // toujours par se declencher, et il pose la valeur juste.
    setTimeout(function () { settled = true; el.textContent = String(target); }, dur + 400);
  }

  var done = false;
  function run() {
    if (done) return;
    done = true;
    sec.classList.add('is-in-view');
    sec.querySelectorAll('[data-adv-count]').forEach(countUp);
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(); io.disconnect(); } });
    }, { threshold: 0.2 });
    io.observe(sec);
  } else {
    run();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
